import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Update } from 'services/financing-proposals';
import { exposeStrapiError } from 'utils';
import { optionsPrazo, statusBanco } from 'utils/options';
import { parseCurrency, unparseCurrency } from 'utils/parsers';
import FormCore from '../../Form/Core';
import Wrapper from '../Wrapper';
import { AddProposalContainer, CompanyButtonContainer } from './styled';

export default function ModalAddProposal({ banco, id }) {
  const { modal, setModal, reloadContent } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  const close = () => setModal(null);
  const formItems = [
    // { ref: 'banco', placeholder: 'Banco', half: true, required:true },
    {
      ref: 'valor_venda',
      placeholder: 'Valor da venda (R$)',
      half: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_entrada',
      placeholder: 'Valor Entrada (R$)',
      half: true,
      type: 'money',
      onBlur: (event) => {
        //console.log(refForm?.current?.getItem("custo_produto"))
        let entrada = formRef?.current?.getItem('valor_entrada') || 0;
        let valor = formRef?.current?.getItem('valor_venda') || 0;
        formRef?.current?.setItem(valor - entrada, 'valor_financiamento');
        //console.log(custProd + custServ + custOutros)
      },
    },
    {
      ref: 'valor_financiamento',
      placeholder: 'Valor Financiado(R$)',
      half: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_parcelas',
      placeholder: 'Valor Parcelas (R$)',
      half: true,
      type: 'money',
    },
    {
      ref: 'data',
      placeholder: 'Data da Primeira parcela',
      half: true,
      type: 'date',
    },
    {
      ref: 'parcelas',
      placeholder: 'Prazo (Parcelas)',
      type: 'select',
      options: optionsPrazo,
      half: true,
    },
    {
      ref: 'status',
      placeholder: 'Status',
      full: true,
      options: statusBanco,
      required: true,
    },
  ];

  useEffect(() => {
    const fillForm = async () => {
      const form = formRef.current;
      if (!form || !form.setItem || !banco) return;
      try {
        if (banco.parcelas || banco.deadline) {
          await form.setItem(banco.parcelas || banco.deadline, 'parcelas');
        }
        if (banco.data) {
          const formattedDate = moment(banco.data, [
            'DD/MM/YYYY',
            'YYYY-MM-DD',
          ]).format('YYYY-MM-DD');
          await form.setItem(formattedDate, 'data');
        }
        if (banco.valor_financiamento) {
          await form.setItem(
            unparseCurrency(banco.valor_financiamento),
            'valor_financiamento'
          );
        }
        if (banco.valor_entrada) {
          await form.setItem(
            unparseCurrency(banco.valor_entrada),
            'valor_entrada'
          );
          await form.setItem(
            unparseCurrency(banco.valor_entrada) +
              unparseCurrency(banco.valor_financiamento),
            'valor_venda'
          );
        }
        if (banco.installment_value) {
          await form.setItem(
            unparseCurrency(banco.installment_value),
            'valor_parcelas'
          );
        }
        if (banco.status) {
          await form.setItem(banco.status.toLowerCase(), 'status');
        }
      } catch (err) {
        console.error('Erro ao setar campos:', err);
      }
    };
    fillForm();
  }, [banco]);

  const save = async () => {
    const form = formRef.current.getForm();
    if (
      (!form?.parcelas || !form?.valor_parcelas) &&
      form?.status === 'aprovado'
    ) {
      toast.error(
        'Para aprovação os campos valor das parcelas e prazo devem ser preenchidos!'
      );
      return;
    }
    //if(loading|| !form) return;
    setLoading(true);
    const payload = {
      id: id,
      propostas_banco: {
        id: banco.id,
        prazo_financiamento: form?.parcelas,
        valor_entrada: unparseCurrency(parseCurrency(form?.valor_entrada)),
        parcelas: form?.carencia,
        valor_parcelas: unparseCurrency(parseCurrency(form?.valor_parcelas)),
        aceito: false,
        valor_financiamento: unparseCurrency(
          parseCurrency(form?.valor_financiamento)
        ),
        status: form?.status,
        data: form?.data || moment().add(1, 'months').format('YYYY-MM-DD'),
      },
    };
    // ...(modal?.register?.propostas_banco||[]),
    // { ...form, prazo_financiamento: form?.parcelas, data: moment()?.add(1, "months")?.format("YYYY-MM-DD") }
    //Validações
    if (form?.data) {
      const formattedDate = moment(
        form?.data,
        ['DD/MM/YYYY', 'YYYY-MM-DD'],
        true
      );
      // Verifica se a data é menor que hoje
      if (formattedDate.isBefore(moment().startOf('day'))) {
        toast.error(
          'A data da primeira parcela não pode ser menor que a data atual'
        );
        //throw new Error("A data não pode ser menor que a data atual");
        setLoading(false);
        return;
      }
    }
    //Verifica se o valor da parcela é maior que o valor do projeto
    if (form?.valor_parcelas > form?.valor_financiamento) {
      toast.error(
        'O valor da parcela não pode ser maior que o valor do financiamento'
      );
      setLoading(false);
      return;
    }
    // Formata a data
    //const finalDate = formattedDate.format("YYYY-MM-DD");
    const result = await Update({ data: payload }, id);
    if (result && !exposeStrapiError(result)) {
      toast.success('Proposta enviada com sucesso');
      if (modal?.reload && typeof modal?.reload === 'function') {
        modal?.reload();
      }
      reloadContent(true);
      close();
    }
    setLoading(false);
  };

  return (
    <>
      <Wrapper>
        <AddProposalContainer>
          <FormCore ref={formRef} formItems={formItems} />
        </AddProposalContainer>
        <CompanyButtonContainer>
          <Button onClick={close} color="lightgrey" border nospace>
            Cancelar
          </Button>
          <Button color="blue" loading={loading} onClick={save} nospace>
            Salvar
          </Button>
        </CompanyButtonContainer>
      </Wrapper>
    </>
  );
}
